import React, { useState, useEffect } from 'react';
import { OtService } from '../services/OtService';

export const PanelAprobacionCoordinador: React.FC = () => {
    const [ordenes, setOrdenes] = useState<any[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const getFirstDayOfMonth = () => {
        const date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
    };

    const getToday = () => new Date().toISOString().split('T')[0];

    const [fechaInicio, setFechaInicio] = useState<string>(getFirstDayOfMonth());
    const [fechaFin, setFechaFin] = useState<string>(getToday());
    const [searchTaller, setSearchTaller] = useState("");

    const cargarOrdenes = async () => {
        if (fechaInicio > fechaFin) {
            console.warn("La fecha de inicio no puede ser mayor a la fecha de fin.");
            return;
        }

        setIsLoading(true);
        try {
            const data = await OtService.fetchOrdenesAdministrativasCoordinacion(fechaInicio, fechaFin, searchTaller);
            setOrdenes(data);
            setSelectedIds([]);
        } catch (error) {
            console.error("Error al cargar las órdenes:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (fechaInicio && fechaFin && fechaInicio <= fechaFin) {
            cargarOrdenes();
        }
    }, [fechaInicio, fechaFin]);

    return (
        <div className="container-fluid py-4">
            <h2 className="mb-4"><i className="fas fa-clipboard-check text-primary me-2"></i> Revisión y Aprobación de Órdenes por Monto</h2>

            <div className="card shadow-sm mb-4 border-0">
                <div className="card-body rounded d-flex gap-3 align-items-end flex-wrap">

                    <div>
                        <label className="small fw-bold text-muted" htmlFor="fechaInicio">Fecha Inicio</label>
                        <input
                            type="date"
                            id="fechaInicio"
                            className="form-control shadow-sm"
                            value={fechaInicio}
                            max={fechaFin}
                            onChange={(e) => setFechaInicio(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="small fw-bold text-muted" htmlFor="fechaFin">Fecha Fin</label>
                        <input
                            type="date"
                            id="fechaFin"
                            className="form-control shadow-sm"
                            value={fechaFin}
                            min={fechaInicio}
                            onChange={(e) => setFechaFin(e.target.value)}
                        />
                    </div>

                    <div className="flex-grow-1">
                        <label className="small fw-bold text-muted">Búsqueda de órdenes: Ingresa la OT o el Taller (Nombre o RFC)</label>
                        <div className="input-group shadow-sm">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar..."
                                value={searchTaller}
                                onChange={(e) => setSearchTaller(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && cargarOrdenes()}
                            />
                            <button className="btn btn-primary" onClick={cargarOrdenes} disabled={isLoading || fechaInicio > fechaFin}>
                                <i className="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>

                    {fechaInicio > fechaFin && (
                        <div className="w-100 text-danger small mt-1">
                            <i className="fas fa-exclamation-triangle"></i> La fecha de inicio debe ser menor o igual a la fecha de fin.
                        </div>
                    )}
                </div>
            </div>

            <div className="card shadow-sm border-0">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead>
                            <tr>
                                <th>OT Folio</th>
                                <th>Bien</th>
                                <th>Taller (RFC)</th>
                                <th>F. Alta</th>
                                <th>Ejecutivo</th>
                                <th>Etapa activa</th>
                                <th className="text-end">Monto Cotizado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan={8} className="text-center py-5"><div className="spinner-border text-primary"></div></td></tr>
                            ) : ordenes.length === 0 ? (
                                <tr><td colSpan={8} className="text-center py-5 text-muted">No se encontraron órdenes por revisar en este periodo.</td></tr>
                            ) : (
                                ordenes.map(ot => (
                                    <tr key={ot.clave_orden_trabajo} className={selectedIds.includes(ot.clave_orden_trabajo) ? 'table-selected' : ''}>
                                        <td><strong>{ot.folio}</strong></td>
                                        <td>{ot.nombre_bien}<br /><small className="text-muted">{ot.numero_serie} - {ot.placa}</small></td>
                                        <td>{ot.taller}<br /><small className="text-muted">{ot.rfc}</small></td>
                                        <td>{ot.fecha_alta.split(' ')[0]}</td>
                                        <td>{ot.usr_asignado}</td>
                                        <td>
                                            <span className="badge bg-light text-dark border">
                                                {ot.nivel_aprobacion_label || ot.etapa_aprobacion_servicio || 'N/D'}
                                            </span>
                                            {!ot.puede_aprobar && (
                                                <small className="d-block text-muted mt-1">Solo lectura</small>
                                            )}
                                        </td>
                                        <td className="text-end fw-bold">${Number(ot.monto_cotizado).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                                        <td>
                                            <a href={`/solicitudServicio?accion=edit&id=${btoa(ot.clave_solicitud_servicio)}`} className="btn btn-sm btn-primary" title="Editar" target="_blank" rel="noopener noreferrer">
                                                <i className="far fa-eye"></i>&nbsp;<span className="d-none d-md-inline">{ot.puede_aprobar ? 'Aprobar' : 'Revisar'}</span>
                                            </a>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PanelAprobacionCoordinador;